var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.3 12.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF92C",
    d: "M14.9 9.6L9.5 1C8.6-.3 6.6-.3 5.8 1L.3 9.6c-.9 1.4.2 3.2 1.9 3.2h10.9c1.7-.1 2.7-1.8 1.8-3.2zm-7.3 1.2c-.3 0-.6-.1-.7-.3-.2-.2-.3-.5-.3-.7 0-.3.1-.6.3-.8.2-.2.5-.3.8-.3.3 0 .6.1.7.3.2.2.3.5.3.8 0 .3-.1.6-.3.8-.2.1-.5.2-.8.2zm1.1-4.1c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.3 0-.6-.1-.7-.3-.2-.2-.3-.5-.3-.8V3.3c0-.3.1-.6.3-.8.2-.2.5-.3.8-.3.3 0 .6.1.7.3.2.2.3.5.3.8v3.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d691a47a6522326061aa0384ffaadb84.svg";
export { ForwardRef as ReactComponent };